import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

import { Link } from "../../../../components/wpl/link/src/index";

const backgroundStyles = css({
    display: "flex",
    padding: "32px 68px",
    alignItems: "center",
    gap: "32px",
    boxShadow: "1px 1px 6px 0px #0000001A",
    overflow: "hidden",
    textAlign: "center",
    backgroundColor: "#FFFFFF",
    maxWidth: "1266px",
    margin: "0px 16px 0px 16px",
    [media.above.md]: {
        padding: "32px 68px"
    },
    [media.below.md]: {
        padding: "32px"
    },
    [media.below.sm]: {
        flexDirection: "column",
        gap: "0px"
    }
});

const imgStyle = css({
    flex: "0",
    width: "200px",
    height: "94px",
    [media.below.sm]: {
        display: "none"
    }
});

const mobileHeaderStyle = css({
    [media.above.sm]: {
        display: "none"
    }
});

const linkStyles = css({
    "minWidth": "120px",
    "a": {
        svg: {
            transition: "transform 0.25s ease-in-out"
        }
    },
    "a:hover": {
        color: "#0065ff",
        textDecoration: "none",
        textShadow: "none",
        svg: {
            transform: `translateX(${token("space.075")})`
        }
    }
});

export const GovTeamTourBanner = () => {
    const intl = useIntl();
    const description = (
        <FormattedMessage
            id="LiftedBar.GovTeamTour.description"
            defaultMessage={`Get your <strong>free ticket</strong> to Team Tour: Government and learn how to work more efficiently, modernize legacy workflows, and improve agility.`}
            values={DEFAULT_VALUES}
        />
    );
    const mobileHeader = (
        <FormattedMessage
            id="LiftedBar.GovTeamTour.mobileHeader"
            defaultMessage={`TEAM TOUR: GOVERNMENT`}
            values={DEFAULT_VALUES}
        />
    );
    const ctaText = intl.formatMessage({
        id: "LiftedBar.GovTeamTour.cta",
        defaultMessage: "Register now"
    });
    const ctaUrl =
        "https://events.atlassian.com/teamtour_government?ref=TTG&utm_source=marketing&utm_campaign=govbar&utm_medium=internal_type=web";

    return (
        <div css={backgroundStyles}>
            <img
                css={imgStyle}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/team-tour_government_attribution-logo.webp"
                alt={intl.formatMessage({
                    id: "LiftedBar.GovTeamTour.logoAltText",
                    defaultMessage: "Team Tour Government text logo"
                })}
            />
            <div css={mobileHeaderStyle}>
                <span>{mobileHeader}</span>
            </div>
            <p>{description}</p>
            <div css={linkStyles}>
                <Link
                    customLinkColor="#0052cc"
                    text={ctaText}
                    href={ctaUrl}
                    type="inline-basic"
                    dataEventProps={{
                        "data-event-component": "linkButton",
                        "data-event-container": "banner-link-button",
                        "data-event": "clicked",
                        "data-product-key": "jiraSoftware"
                    }}
                />
            </div>
        </div>
    );
};
